import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TRANSLATIONS, ROUTE_MAPS } from "../translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [lang, setLang] = useState("da");

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/en")) {
      setLang("en");
    } else {
      setLang("da");
    }
  }, [location.pathname]);

  const t = TRANSLATIONS[lang];

  const changeLanguage = (targetLang) => {
    if (targetLang === lang) return;

    const currentPath = location.pathname;
    let currentKey = "home";

    // Match the current path to a route key
    if (currentPath === "/da/heste/salg" || currentPath === "/en/horses/sales") {
      currentKey = "horses_sales";
    } else if (currentPath === "/da/heste/sportsheste" || currentPath === "/en/horses/sport-horses") {
      currentKey = "horses_sport";
    } else {
      // Find matching key in ROUTE_MAPS
      for (const [key, path] of Object.entries(ROUTE_MAPS[lang])) {
        if (currentPath === path) {
          currentKey = key;
          break;
        }
      }
    }

    const targetUrl = ROUTE_MAPS[targetLang][currentKey] || ROUTE_MAPS[targetLang].home;
    navigate(targetUrl);
  };

  return (
    <LanguageContext.Provider value={{ lang, t, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
